<button *ngIf="!isSameView(contextMenuObject)" class="dropdown-item" [routerLink]="getItemFullPageRoute(contextMenuObject)"
        [innerHTML]="'context-menu.actions.show-all-metadata' | translate">
</button>
